<script>
    import { strings } from '../utils';

    export default {
        data: function () {
            return {
                displayVal: '',
            };
        },
        props: {
            value: {
                type: [String, Number],
                default: '',
            },
            label: {
                type: String,
                default: '',
            },
            description: {
                type: String,
                default: '',
            },
            name: {
                type: String,
                default: strings.random(),
            },
            disabled: {
                type: Boolean,
                default: false,
            },
            readonly: {
                type: Boolean,
                default: false
            },
            required: {
                type: Boolean,
                default: false,
            },
            width: {
                type: String,
            },
            height: {
                type: String,
            },
            paddingTop: {
                type: [String, Number],
            },
            paddingBottom: {
                type: [String, Number],
            },
            paddingLeft: {
                type: [String, Number],
            },
            extraInfo: {
                type: [Boolean, String],
                default: false,
            },
            inputPadding: {
                type: String,
            },
            layout: {
                type: String,
                default: 'vertical',
                validator(value) {
                    return value === 'vertical' || value === 'horizontal';
                },
            },
            display: {
                type: String,
                default: 'flex',
                validator(value) {
                    return value === 'flex' || value === 'inline-flex';
                },
            },
            border: {
                type: String,
                validator(value) {
                    return ['top', 'bottom', 'both'].includes(value);
                },
            },
            id: {
                type: String,
            },
        },
        computed: {
            labelStyles() {
                let styles = {
                    position: this.layout === 'vertical' ? 'absolute' : 'static',
                };

                if (this.paddingLeft) {
                    styles.paddingLeft = this.paddingLeft;
                }

                return styles;
            },
            selectStyles() {
                return {
                    width: this.width || '200px',
                };
            },
            inputStyles() {
                return {
                    width: this.width || '100%',
                    padding: this.inputPadding || '',
                };
            },
            wrapperStyles() {
                let styles = {
                    height: this.height || 'auto',
                    paddingBottom: this.paddingBottom,
                    display: this.display,
                };

                if (this.paddingTop) {
                    styles.paddingTop = this.paddingTop;
                } else if (this.layout !== 'vertical') {
                    styles.paddingTop = '1em';
                } else if (this.type === 'FormSelect') {
                    styles.paddingTop = '2em';
                } else if (!this.label) {
                    styles.paddingTop = '1em';
                } else {
                    styles.paddingTop = '2em';
                }

                if (this.paddingBottom) {
                    styles.paddingBottom = this.paddingBottom;
                } else if (this.border === 'bottom' || this.border === 'both') {
                    styles.paddingBottom = '1em';
                } else {
                    styles.paddingBottom = '0';
                }

                if (this.border === 'top' || this.border === 'both') {
                    styles.marginTop = styles.paddingTop;
                }

                if (this.border === 'bottom' || this.border === 'both') {
                    styles.marginBottom = styles.paddingBottom;
                }

                if (this.layout === 'vertical') {
                    styles.flexDirection = 'column';
                    styles.justifyContent = 'flex-start';
                } else {
                    styles.flexDirection = 'row';
                    styles.justifyContent = 'space-between';
                    styles.alignItems = 'center';
                }

                return styles;
            },
            wrapperClasses() {
                let classes = ['control-wrapper', this.layout];
                if (this.border === 'top' || this.border === 'both') classes.push('border-top');
                if (this.border === 'bottom' || this.border === 'both') classes.push('border-bottom');
                if (this.displayVal || this.displayVal === 0) classes.push('filled');

                return classes;
            },
            extraInfoStyles() {
                return {
                    position: this.layout === 'vertical' ? '' : 'relative',
                    top: this.layout === 'vertical' ? '' : '-0.4em',
                    left: this.layout === 'vertical' ? '' : '0.4em',
                };
            },
        },
        methods: {
            onInput(e) {
                const val = typeof e === 'object' ? e.target.value : e;
                this.$emit('input', val);
            },
            onChange(e) {
                const val = typeof e === 'object' ? e.target.value : e;
                this.displayVal = val;
                this.$emit('change', val);
            },
            onKeydown(e) {
                this.$emit('keydown', e);
            },
            onFocus(e) {
                this.$emit('focus', e);
            },
            onBlur(e) {
                this.$emit('blur', e);
            },
            async focus() {
                await this.$nextTick();
                this.$refs[this.name].focus();
            },
            async blur() {
                await this.$nextTick();
                this.$refs[this.name].blur();
            },
        },
        watch: {
            value(val) {
                this.displayVal = this.value;
            },
        },
        mounted() {
            this.displayVal = this.value;
        },
    };
</script>